import React from "react";
import "./Wave.css";

export const Wave = () => {
  return (
    <svg
      id="wave"
      version="1.1"
      viewBox="0 0 1440 135"
      className="wave"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="0" y2="0">
          <stop stopColor="rgba(101, 131, 157, 1)" offset="0%"></stop>
          <stop stopColor="rgba(101, 131, 157, 1)" offset="100%"></stop>
        </linearGradient>
      </defs>
      <path
        style={{ transform: "translate(0, 0px)", opacity: 1 }}
        fill="url(#sw-gradient-0)"
        d="M0,28L20,23.3C40,19,80,9,120,4.7C160,0,200,0,240,14C280,28,320,56,360,63C400,70,440,56,480,60.7C520,65,560,89,600,91C640,93,680,75,720,67.7C760,61,800,65,840,70C880,75,920,79,960,81.7C1000,84,1040,84,1080,77C1120,70,1160,56,1200,56C1240,56,1280,70,1320,72.3C1360,75,1400,65,1440,53.7C1480,42,1520,28,1560,18.7C1600,9,1640,5,1680,2.3C1720,0,1760,0,1800,21C1840,42,1880,84,1920,95.7C1960,107,2000,89,2040,77C2080,65,2120,61,2160,65.3C2200,70,2240,84,2280,86.3C2320,89,2360,79,2400,70C2440,61,2480,51,2520,49C2560,47,2600,51,2640,63C2680,75,2720,93,2760,98C2800,103,2840,93,2860,88.7L2880,84L2880,140L2860,140C2840,140,2800,140,2760,140C2720,140,2680,140,2640,140C2600,140,2560,140,2520,140C2480,140,2440,140,2400,140C2360,140,2320,140,2280,140C2240,140,2200,140,2160,140C2120,140,2080,140,2040,140C2000,140,1960,140,1920,140C1880,140,1840,140,1800,140C1760,140,1720,140,1680,140C1640,140,1600,140,1560,140C1520,140,1480,140,1440,140C1400,140,1360,140,1320,140C1280,140,1240,140,1200,140C1160,140,1120,140,1080,140C1040,140,1000,140,960,140C920,140,880,140,840,140C800,140,760,140,720,140C680,140,640,140,600,140C560,140,520,140,480,140C440,140,400,140,360,140C320,140,280,140,240,140C200,140,160,140,120,140C80,140,40,140,20,140L0,140Z"
      ></path>
    </svg>
  );
};
